import { API } from "aws-amplify";
import {
  LIST_CUSTOM_SLOT_TYPES,
  CREATE_NEW_CUSTOM_SLOT_TYPE,
  CLEAR_LIST_OF_CUSTOM_SLOT_TYPES,
  DELETE_CUSTOM_SLOT_TYPE,
  UPDATE_CUSTOM_SLOT_TYPE,
  GENERATE_SKILL_BUILDER_CODE,
  CLEAR_DELETE_CUSTOM_SLOT_TYPE_RESPONSE,
  CLEAR_CREATED_CUSTOM_SLOT_TYPE_RESPONSE,
  CLEAR_UPDATE_CUSTOM_SLOT_TYPE_RESPONSE,
  CLEAR_ALL_CUSTOM_SLOTS_STATE
} from "./types";

import {getEnvironmentName} from "../../utils"
const environment = getEnvironmentName()
const config = require("../../app_configuration").CONFIGURATION[environment];

const apiRequestFixedParams = {
  Version: config.RESPONSUM_API_VERSION,
  Api: config.RESPONSUM_API,
  AccountType: config.RESPONSUM_API_RESOURCE_TYPE.PRIVATE
};

export const listCustomSlotTypes = () => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GetCustomSlots",
      Skill: state.skill.appId,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: LIST_CUSTOM_SLOT_TYPES,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "intent-slots/custom", requestData);
  } catch (err) {
    action.payload.response = { status: "error", code: 500, message: "Could not retrieve custom slot types" };
  }

  dispatch(action);
};

export const clearListOfCustomSlotTypes = () => {
  return {
    type: CLEAR_LIST_OF_CUSTOM_SLOT_TYPES
  };
};

export const clearDeleteCustomSlotTypeResponse = () => {
  return {
    type: CLEAR_DELETE_CUSTOM_SLOT_TYPE_RESPONSE
  };
};

export const clearCreatedCustomSlotTypeResponse = () => {
  return {
    type: CLEAR_CREATED_CUSTOM_SLOT_TYPE_RESPONSE
  };
};

export const clearUpdateCustomSlotTypeResponse = () => {
  return {
    type: CLEAR_UPDATE_CUSTOM_SLOT_TYPE_RESPONSE
  };
};

export const clearAllCustomSlotsState = () => {
  return {
    type: CLEAR_ALL_CUSTOM_SLOTS_STATE
  };
};

export const createNewCustomSlot = customSlotTypeName => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      FormParams: `custom_slot_type=${encodeURIComponent(customSlotTypeName)}&custom_slot_id=&custom_slot_values=`,
      ApiCall: "CreateCustomSlot",
      Skill: state.skill.appId,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: CREATE_NEW_CUSTOM_SLOT_TYPE,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "intent-slots/custom", requestData);
  } catch (err) {
    action.payload.response = { status: "error", code: 500, message: "Could not create custom slot type" };
  }

  dispatch(action);
};

export const updateCustomSlotType = serializedCustomSlotType => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      FormParams: serializedCustomSlotType,
      ApiCall: "CreateCustomSlot",
      Skill: state.skill.appId,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: UPDATE_CUSTOM_SLOT_TYPE,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "intent-slots/custom", requestData);
  } catch (err) {
    action.payload.response = { status: "error", code: 500, message: "Could not create custom slot type" };
  }

  dispatch(action);
};

export const generateSkillBuilderCode = () => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "GenerateSkillBuilderCode",
      Skill: state.skill.appId,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: GENERATE_SKILL_BUILDER_CODE,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "skill/alexa-app-code", requestData);
  } catch (err) {
    action.payload.response = { status: "error", code: 500, message: "Could not generate skill builder code" };
  }

  dispatch(action);
};

export const deleteCustomSlotType = slotTypeId => async (dispatch, getState) => {
  const state = getState();

  const requestData = {
    body: {
      AccessToken: state.auth.cognitoUser.signInUserSession.accessToken.jwtToken,
      ApiCall: "DeleteCustomSlot",
      Skill: state.skill.appId,
      Slot: slotTypeId,
      ...apiRequestFixedParams
    }
  };

  const action = {
    type: DELETE_CUSTOM_SLOT_TYPE,
    payload: { response: {} }
  };

  try {
    action.payload.response = await API.post(config.AWS_API_NAME, "intent-slots/custom", requestData);
  } catch (err) {
    action.payload.response = { status: "error", code: 500, message: "Could not delete custom slot type" };
  }

  dispatch(action);
};
